import React, { useState, useRef, useImperativeHandle, useEffect, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";

import Editor from "ckeditor5-custom-build/build/ckeditor";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { CKEditorOptions } from "util";
import { PreviewContainer } from "util/component/CKEditorPreview";

import { useTranslation } from "react-i18next";

import { html_render } from "pages/Review/Functions";

const EditorApp = (props, _ref) => {
    const [Hide, SetHide] = useState(false);
    const [PreviewOpen, SetPreviewOpen] = useState(null);
    const quillRef = useRef(null);
    const reviewRef = useRef(null);
    const editorViewerRef = useRef(null);

    const [WEB_CONTENT, SET_WEB_CONTENT] = useState(null);

    const { t } = useTranslation(["page"]);

    const HandleHide = () => {
        SetHide(!Hide);
    };

    useImperativeHandle(_ref, () => ({
        getValue: () => {
            const chk = document.createElement("div");
            chk.innerHTML = quillRef.current.getData();

            chk.querySelectorAll("[data-uniquecode]").forEach((e) => {
                const uniquecode = e.dataset.uniquecode;
                const chkcnt = chk.querySelectorAll(`[data-uniquecode="${uniquecode}"]`);
                
                if (chkcnt.length > 1) {
                    let flag = false;
                    
                    for (let i = 0; i < chkcnt.length; i++) {
                        if(!chkcnt[i].innerText.replaceAll(/[\W]+/g,"") || flag) {
                            chkcnt[i]?.removeAttribute("data-uniquecode");
                        } else {
                            flag = true;
                        }
                    }
                }
            });
            const returnValue = chk.innerHTML;
            return returnValue;
        },
    }));

    const HandleReviewEvent = ({ target }) => {
        const isUniqueCode = target?.closest("[data-uniquecode]");
        if (!isUniqueCode) return;

        const uniqueCode = isUniqueCode.dataset.uniquecode;

        if (!uniqueCode) return;

        reviewRef.current.querySelectorAll(".selected").forEach((e) => {
            e.classList.remove("selected");
        });
        target.classList.add("selected");

        props?.onOpen && props.onOpen({ name: "Description Review Data", revType: "D" }, uniqueCode);

        const editortarget = editorViewerRef.current.querySelector("[data-uniquecode='" + uniqueCode + "']");
        if (!editortarget) return;

        editortarget.classList.add("bpl-review-selected");
        setTimeout(() => {
            editortarget.classList.remove("bpl-review-selected");
        }, 5000);
        const elementPosition = editortarget.getBoundingClientRect();
        const offsetPosition = elementPosition.top + window.pageYOffset - 200;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        reviewRef.current?.addEventListener("click", HandleReviewEvent);
        return () => {
            reviewRef.current?.removeEventListener("click", HandleReviewEvent);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [WEB_CONTENT]);

    useEffect(() => {
        let innerhtml = props?.webContent;
        const search = new URLSearchParams(window.location.search);
        if (search.get("copy") === "Y" && innerhtml) {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = props?.webContent;
            tempDiv.querySelectorAll("*[data-uniquecode]").forEach(element => {
                element.removeAttribute("data-uniquecode");
            })
            innerhtml = tempDiv.innerHTML;
        }
        quillRef.current?.setData(innerhtml);

    }, [props.webContent]);

    const PreviewHandler = (index) => {
        const html = quillRef.current.getData();
        SetPreviewOpen(html);
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const HandleSetPreviewOpen = () => {
        SetPreviewOpen(null);
    };

    const HandleChangeEvent = (editor) => {
        const { reviewData } = props;
        const review = reviewData?.filter((f) => f.celNm === "Description Review Data");
        const content = editor?.getData();
        const a = html_render(content, review);
        SET_WEB_CONTENT(a);
    };

    useEffect(() => {
        if (props.reviewData && props.reviewData.length > 0) {
            HandleChangeEvent(quillRef.current);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.reviewData]);

    return (
        <section className="create" style={{ position: "initial" }}>
            <div className={"tbl_box2 " + (Hide ? "hide" : "")}>
                <div className="d-flex align-center gap-20">
                    <h1 className={"title "} onClick={HandleHide}>
                        {"Sheet Description"} <FontAwesomeIcon icon={faAngleUp} />
                    </h1>
                    <button
                        className={"bpl-btn success"}
                        onClick={() => {
                            PreviewHandler();
                        }}
                    >
                        {t("preview")}
                    </button>
                </div>

                <div className="data_table editor-div">
                    <div className={"editor-aria"} ref={editorViewerRef}>
                        <CKEditor
                            editor={Editor}
                            config={CKEditorOptions}
                            watchdogConfig={{ crashNumberLimit: 10 }}
                            onReady={(editor) => {
                                window.editor = editor;
                                quillRef.current = editor;
                                editor.editing.view.document.on('clipboardInput', (evt, data) => {

                                    const dt = data.dataTransfer;
                                    const content = dt.getData("text/plain");

                                    data.content = editor.data.htmlProcessor.toView(content);
                                    const editingView = editor.editing.view;
                                    editingView.scrollToTheSelection();
                                })
                            }}
                            onChange={(event, editor) => {
                                HandleChangeEvent(editor);
                            }}
                        />
                    </div>
                    <div className={"view-area"}>
                        <div className={"inner"}>
                            <div className={"inner2"}>
                                <div className={"name-plate"}><span>Preview</span></div>
                                <div ref={reviewRef} className={"ck-content"} dangerouslySetInnerHTML={{ __html: WEB_CONTENT || "" }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {PreviewOpen !== null && (
                <PreviewContainer position={"fixed"} onClose={HandleSetPreviewOpen}>
                    {PreviewOpen}
                </PreviewContainer>
            )}
        </section>
    );
};

export default React.forwardRef(EditorApp);
